// Client V2 common imports
const { createFeedSelectors } = require('client-v2/common/containers/feed/selectors')
// Container imports
const EmptyCollectionCard = require('./components/empty-collection-card')
const {
  EmptyContentMessage,
  EmptyFollowersMessage,
  EmptyFollowingMessage,
  EmptySelfPostsMessage,
  EmptySubscribedMessage
} = require('./components/empty-message')

const feedSelectors = createFeedSelectors('feed')

function isSelfProfileState(state) {
  return state.profileUser.id === state.user.id
}

function isItemsEmptyState(state) {
  const isMixes = state.router.action === 'user-profile.showCollectionsCreated'
  const items = feedSelectors.getDenormalizedItems(state)
  if (isMixes && items.size === 1) {
    const item = items.get(0)
    return (
      item.type === 'mix' &&
      item.collection.slug === 'general' &&
      !item.collection['posts_count']
    )
  }
  return !items.size
}

function emptyCardState(state) {
  if (
    !isSelfProfileState(state) ||
    !isItemsEmptyState(state)
  ) {
    return null
  }
  switch (state.router.action) {
    case 'user-profile.showCollectionsCreated':
      return EmptyCollectionCard
    case 'user-profile.showPosts':
    case 'user-profile.showCollectionsSubscribed':
    case 'user-profile.showFollowers':
    case 'user-profile.showFriends':
    default:
      return null // TODO
  }
}

function emptyMessageState(state) {
  const isSelfProfile = isSelfProfileState(state)
  if (!isItemsEmptyState(state)) {
    return null
  }
  switch (state.router.action) {
    case 'user-profile.showPosts':
      return isSelfProfile ? EmptySelfPostsMessage : EmptyContentMessage
    case 'user-profile.showCollectionsCreated':
      return isSelfProfile ? null : EmptyContentMessage
    case 'user-profile.showCollectionsSubscribed':
      return EmptySubscribedMessage
    case 'user-profile.showFollowers':
      return EmptyFollowersMessage
    case 'user-profile.showFriends':
      return EmptyFollowingMessage
  }
}

module.exports = Object.assign(feedSelectors, {
  emptyCardState,
  emptyMessageState,
  isItemsEmptyState,
  isSelfProfileState
})
